import { useLocation, Navigate } from "react-router-dom";
import React, { useCallback } from "react";
import * as XLSX from "xlsx";
import { FileDownload } from "@mui/icons-material";
import { useSelector } from "react-redux";
import ExportIcon from "@rsuite/icons/Export";
import axios from "axios";
import { Button } from "rsuite";
import jsPDF from "jspdf";
//import autoTable from "jspdf-autotable";
import "jspdf-autotable";
export function RequireAuth({ children }) {
  const user = useSelector((state) => state.nameReducer.user);
  console.log(user);
  //const [user, setUser] = React.useState(true)
  let location = useLocation();
  if (!user.uid) {
    return <Navigate to="/" state={{ from: location }} replace />;
  } else {
    return children;
  }
}
export function ellipsify(str) {
  if (str.length > 30) {
    return str.substring(0, 30) + "...";
  } else {
    return str;
  }
}
export function TableToPDF() {
  const doc = new jsPDF();

  const companyDetails = {
    name: "Your Company Name",
    address: "Company Address",
    city: "City",
    state: "State",
    zip: "Zip",
    phone: "Phone Number",
    email: "Email Address",
  };

  // Set up header and footer
  const header = function (data) {
    doc.setFontSize(18);
    //doc.setFontStyle("bold");

    doc.text("Statement", data.settings.margin.left, 10);
  };
  var totalPagesExp = doc.totalPagesExp;
  const footer = function (data) {
    /*     const pageCount = doc.internal.getNumberOfPages();
    doc.setFontSize(12);
    doc.text(
      "Page " + data.pageNumber + " of " + pageCount,
      data.settings.margin.left,
      doc.internal.pageSize.height - 10
    ); */
    // Footer
    var str = "Page " + doc.internal.getNumberOfPages();
    // Total page number plugin only available in jspdf v1.0+
    if (typeof doc.putTotalPages === "function") {
      str = str + " of " + totalPagesExp;
    }
    doc.setFontSize(10);

    // jsPDF 1.4+ uses getHeight, <1.4 uses .height
    var pageSize = doc.internal.pageSize;
    var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
    doc.text(str, data.settings.margin.left, pageHeight - 10);
  };
  doc.autoTable({
    startY: 20,
    styles: { overflow: "linebreak" },
    body: Object.entries(companyDetails),
    columnStyles: { 0: { fontStyle: "bold" } },
    didDrawPage: function (data) {
      // Header
      header(data);

      // Footer
      footer(data);
    },
  });
  doc.autoTable({ html: "#TableData", startY: 80 });
  const lastY = doc.lastAutoTable.finalY;
  //doc.text("End of table ", doc.internal.pageSize.height - 20);
  doc.text("With content", 14, lastY + 10);
  doc.save("table.pdf");
}
export function Table2XLSX({
  tableID = "TableData",
  exportFileName = "Export",
  loading = false,
  setloading,
}) {
  const [processing, setProcessing] = React.useState(loading);
  /* Callback invoked when the button is clicked */
  const handleExport = useCallback(async () => {
    /* Create worksheet from HTML DOM TABLE */
    const table = document.getElementById(tableID);
    const wb = XLSX.utils.table_to_book(table);
    XLSX.utils.sheet_add_aoa(wb, [["Created " + new Date().toISOString()]], {
      origin: -1,
    });
    XLSX.writeFile(wb, `${exportFileName}.xlsx`);
  }, []);
  return (
    <Button
      color="green"
      appearance="subtle"
      onClick={handleExport}
      loading={loading}
    >
      <ExportIcon style={{ margin: "5px" }} /> Export
    </Button>
  );
}

export function Table2XLSXNew({
  tableID = "TableData",
  exportFileName = "Export",
  loading = false,
  setloading,
}) {
  //const [processing, setProcessing] = React.useState(loading);
  /* Callback invoked when the button is clicked */
  const handleExport = useCallback(async () => {
    /* Create worksheet from HTML DOM TABLE */
    const table = document.getElementById(tableID);
    const wb = XLSX.utils.table_to_book(table);
    XLSX.utils.sheet_add_aoa(wb, [["Created " + new Date().toISOString()]], {
      origin: -1,
    });
    XLSX.writeFile(wb, `${exportFileName}.xlsx`);
  }, []);
  return (
    <Button
      color="info"
      appearance="primary"
      onClick={handleExport}
      loading={loading}
    >
      <FileDownload /> Export
    </Button>
  );
}

export function NewAPIAddress(add) {
  const Domain = "https://api.laxmaninterior.in/";
  return Domain + add + ".php";
}

export function ValidateEmail(inputText) {
  var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  if (inputText.match(mailformat)) {
    return true;
  } else {
    return false;
  }
}

export function validateNumber(val) {
  var phoneno = /^\d{10}$/;
  if (val.match(phoneno)) {
    return true;
  } else {
    return false;
  }
}

export function validateOnlyNumber(val) {
  var no = /^\d$/;
  console.log(val.match(no));
  if (val.match(no)) {
    return true;
  } else {
    return false;
  }
}

export function number2text(value) {
  var fraction = Math.round(frac(value) * 100);
  var f_text = "";

  if (fraction > 0) {
    f_text = "AND " + convert_number(fraction) + " PAISE";
  }

  return convert_number(value) + " RUPEE(S) " + f_text + " ONLY";
}

function frac(f) {
  return f % 1;
}

function convert_number(number) {
  if (number < 0 || number > 999999999) {
    return "NUMBER OUT OF RANGE!";
  }
  var Gn = Math.floor(number / 10000000); /* Crore */
  number -= Gn * 10000000;
  var kn = Math.floor(number / 100000); /* lakhs */
  number -= kn * 100000;
  var Hn = Math.floor(number / 1000); /* thousand */
  number -= Hn * 1000;
  var Dn = Math.floor(number / 100); /* Tens (deca) */
  number = number % 100; /* Ones */
  var tn = Math.floor(number / 10);
  var one = Math.floor(number % 10);
  var res = "";

  if (Gn > 0) {
    res += convert_number(Gn) + " CRORE";
  }
  if (kn > 0) {
    res += (res === "" ? "" : " ") + convert_number(kn) + " LAKH";
  }
  if (Hn > 0) {
    res += (res === "" ? "" : " ") + convert_number(Hn) + " THOUSAND";
  }

  if (Dn) {
    res += (res === "" ? "" : " ") + convert_number(Dn) + " HUNDRED";
  }

  var ones = Array(
    "",
    "ONE",
    "TWO",
    "THREE",
    "FOUR",
    "FIVE",
    "SIX",
    "SEVEN",
    "EIGHT",
    "NINE",
    "TEN",
    "ELEVEN",
    "TWELVE",
    "THIRTEEN",
    "FOURTEEN",
    "FIFTEEN",
    "SIXTEEN",
    "SEVENTEEN",
    "EIGHTEEN",
    "NINETEEN"
  );
  var tens = Array(
    "",
    "",
    "TWENTY",
    "THIRTY",
    "FOURTY",
    "FIFTY",
    "SIXTY",
    "SEVENTY",
    "EIGHTY",
    "NINETY"
  );

  if (tn > 0 || one > 0) {
    if (!(res === "")) {
      res += " AND ";
    }
    if (tn < 2) {
      res += ones[tn * 10 + one];
    } else {
      res += tens[tn];
      if (one > 0) {
        res += "-" + ones[one];
      }
    }
  }

  if (res === "") {
    res = "zero";
  }
  return res;
}
export function GetLastDay(date) {
  var year = date.getFullYear(),
    month = date.getMonth();
  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0);
  return lastDay;
}

function getOperatingSystem(window) {
  let operatingSystem = "Not known";
  if (window.navigator.appVersion.indexOf("Win") !== -1) {
    operatingSystem = "Windows OS";
  }
  if (window.navigator.appVersion.indexOf("Mac") !== -1) {
    operatingSystem = "MacOS";
  }
  if (window.navigator.appVersion.indexOf("X11") !== -1) {
    operatingSystem = "UNIX OS";
  }
  if (window.navigator.appVersion.indexOf("Linux") !== -1) {
    operatingSystem = "Linux OS";
  }

  return operatingSystem;
}

function getBrowser(window) {
  let currentBrowser = "Not known";
  if (window.navigator.userAgent.indexOf("Chrome") !== -1) {
    currentBrowser = "Google Chrome";
  } else if (window.navigator.userAgent.indexOf("Firefox") !== -1) {
    currentBrowser = "Mozilla Firefox";
  } else if (window.navigator.userAgent.indexOf("MSIE") !== -1) {
    currentBrowser = "Internet Exployer";
  } else if (window.navigator.userAgent.indexOf("Edge") !== -1) {
    currentBrowser = "Edge";
  } else if (window.navigator.userAgent.indexOf("Safari") !== -1) {
    currentBrowser = "Safari";
  } else if (window.navigator.userAgent.indexOf("Opera") !== -1) {
    currentBrowser = "Opera";
  } else if (window.navigator.userAgent.indexOf("Opera") !== -1) {
    currentBrowser = "YaBrowser";
  } else {
    console.log("Others");
  }

  return currentBrowser;
}

export const OS = (window) => getOperatingSystem(window);
export const currentBrowser = (window) => getBrowser(window);

export function sendFCMPushNotification(
  title,
  message,
  NotificationTo = "Admin"
) {
  axios
    .post("https://api.laxmaninterior.in/AddNotification.php", {
      Data: message,
    })
    .then((response) => {
      const result = response.data;
      if (result.status === 1) {
      }
    })
    .catch((e) => {
      console.log(e);
    });
  const GetIDAddress =
    NotificationTo === "Support"
      ? "https://api.laxmaninterior.in/GetSupportID.php"
      : "https://api.laxmaninterior.in/GetAdminID.php";
  let RecipientID = "";
  axios
    .get(GetIDAddress)
    .then(async function (response) {
      const data = response.data;
      console.log(data);
      if (data.status === 1) {
        RecipientID = data.Data[0].DeviceID;
        console.log(RecipientID);
        try {
          fetch("https://fcm.googleapis.com/fcm/send", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `key=AAAA7Cd7k4E:APA91bE6UDEOgTyHbrvcedTWDRqf5uC7CB0UPZtCI6n9XM6Z_M8k5HGVyvkTeniihE1kibbcwUBDK1qmrefNupAnJ2Z7iwOZUNGqEojZ7TSOlWYLNSq7aMIdUdF9-L-sAn579AJl6yx6`,
            },
            body: JSON.stringify({
              to: RecipientID,
              priority: "normal",
              data: {
                title,
                message,
              },
            }),
          })
            .then((a) => {
              console.log(a);
            })
            .catch((e) => console.log(e));
        } catch (error) {}
      }
    })
    .catch(function (error) {
      console.log(error);
    })
    .then(function () {});
}

export const filterParams = {
  comparator: (filterLocalDateAtMidnight, cellValue) => {
    var dateAsString = cellValue;
    if (dateAsString == null) return -1;
    var dateParts = dateAsString.split("/");
    var cellDate = new Date(
      Number(dateParts[2]),
      Number(dateParts[1]) - 1,
      Number(dateParts[0])
    );

    if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
      return 0;
    }

    if (cellDate < filterLocalDateAtMidnight) {
      return -1;
    }

    if (cellDate > filterLocalDateAtMidnight) {
      return 1;
    }
    return 0;
  },
  minValidYear: 1950,
  maxValidYear: 2050,
  inRangeFloatingFilterDateFormat: "DD/MM/YYYY",
};

export const ProperFormat = (val) => {
  return val.value
    ? val.value.replace(
        /\w\S*/g,
        (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
      )
    : "";
};
